<template>
    <td>
       <h5><span v-for="(valor, i)  in getValores()" :key="i" class="badge badge-pill badge-info">{{valor.nombre}}</span></h5>
    </td>
</template>
<script>
import Axios from 'axios';
export default {
    props: [
        'value',
        'data',
        'table',
        'index'
    ],
    data () {
        return {
        }
    },
    methods: {
        getValores(){
            let valores = []
            if (Array.isArray(this.table) && Array.isArray(this.value)){
                const selected = this.value.map(e=>parseInt(e))
                for (let i = 0; i < this.table.length; i++) {
                    const element = this.table[i];
                    if (selected.includes(parseInt(this.table[i].id))) {
                        valores.push(element)
                    }
                }
            }
            return valores
        }
    }
}
</script>
